













































































import {Component, Mixins, Prop, Ref} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import {Dialog} from 'element-ui'
import FooterButton from '@/components/FooterButton.vue'

@Component({
  components: {
    [Dialog.name]: Dialog, FooterButton,
  }
})
export default class InvoiceViewAsDocumentPopup extends Mixins(Translation) {
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: '', type: String}) data: string
  @Prop({default: false, type: Boolean}) hasFooter: boolean
  @Prop({default: '', type: String}) footerText: string

  @Ref('zoomer') zoomer: any

  loading: boolean = true

  onClose() {
    this.$emit('input', false)
    this.zoomer?.reset()
  }

  onClick(e) {
    const targetTagName = e?.target?.tagName
    const targetClassNames = e?.target?.className || ''
    if(targetTagName === 'DIV' && (targetClassNames.includes('el-dialog__wrapper') || targetClassNames.includes('el-dialog'))) {
      this.onClose()
    }
  }

  onClickFooter() {
    this.$emit('click-footer')
    this.onClose()
  }

  onOpened() {
    const zoomer: any = this.zoomer
    const windowHeight = window.innerHeight
    const HEADER_HEIGHT = 79
    const FOOTER_HEIGHT = 105
    zoomer?.$el?.setAttribute('style', `height: ${windowHeight - (HEADER_HEIGHT + FOOTER_HEIGHT)}px`)
  }

  onLoad() {
    this.loading = false
  }
}
